<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    close (flag) {
      this.$emit('close', flag);
    },
  },
};
</script>

<template>
  <div
    v-if="show"
    class="bdk-preflight bdk-banner bdk-fixed bdk-bottom-0 bdk-inset-x-0 bdk-pb-2 sm:bdk-pb-5"
  >
    <div
      class="bdk-max-w-7xl bdk-mx-auto bdk-px-2 sm:bdk-px-6 lg:bdk-px-8"
    >
      <div
        class="bdk-p-2 bdk-rounded-lg bdk-bg-white bdk-shadow-lg sm:bdk-p-3"
      >
        <div
          class="bdk-flex bdk-items-center bdk-justify-center"
        >
          <div
            class="bdk-w-0 bdk-flex-1 bdk-flex bdk-items-center bdk-flex-grow"
          >
            <div
              class="bdk-ml-3 bdk-font-medium bdk-text-gray-500 bdk-truncate bdk-flex bdk-items-center"
            >
              <span
                class="md:bdk-hidden bdk-text-sm"
                v-text="__('Nós usamos Cookies neste site.')"
              />

              <span
                class="bdk-hidden md:bdk-inline bdk-text-sm"
                v-text="__('Nós usamos Cookies para proporcionar experiências personalizadas para cada um dos visitantes.')"
              />
            </div>
          </div>

          <div
            class="bdk-order-3 bdk-mt-2 bdk-flex-shrink-0 bdk-w-full sm:bdk-order-2 sm:bdk-mt-0 sm:bdk-w-auto bdk-inline-flex bdk-items-center bdk-justify-center"
          >
            <div
              @click.prevent="close(false)"
              id="allowTrackingButton"
              v-text="__('PERMITIR TODOS OS COOKIES')"
              class="bdk-flex bdk-items-center bdk-cursor-pointer bdk-justify-center bdk-px-4 bdk-py-2 bdk-border bdk-border-transparent bdk-rounded-md bdk-text-sm bdk-font-medium bdk-text-indigo-600 bdk-bg-white hover:bdk-bg-indigo-50"
            />

            <div
              @click.prevent="close(true)"
              id="deniedTrackingButton"
              v-text="__('NÃO, OBRIGADO!')"
              class="bdk-flex bdk-items-center bdk-cursor-pointer bdk-justify-center bdk-px-1 bdk-border bdk-border-transparent bdk-rounded-md bdk-text-xs bdk-font-medium bdk-text-gray-500 bdk-bg-white"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .bdk-banner {
    z-index: 9999999;
  }
</style>
